var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTable',{attrs:{"items":_vm.rows,"columns":_vm.columns,"is-loading":_vm.isLoading},on:{"row-click":_vm.handleRowClick},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(_vm.enumToHumanReadable(item.type))+"\n    ")]}},{key:"status",fn:function(ref){
var item = ref.item;
return [_c('label',{class:['badge', _vm.getStatusClass(item.status)]},[_vm._v("\n        "+_vm._s(item.status)+"\n      ")])]}},{key:"chevron",fn:function(){return [_c('div',{staticClass:"text-right"},[_c('i',{staticClass:"fas fa-chevron-right text-muted"})])]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20cfaaf5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contacts/ContactsTable.vue
// module id = null
// module chunks = 